import { HeaderTabs } from '@/shared/ui';

import { orderLayoutCopy } from './copy';
import type { OrderTab } from './order-tabs';

export interface OrderTabsProps {
    tabs: readonly OrderTab[];
}

/**
 * De tabbladen onderaan de kop van een keuring: Overzicht, Opname, Rapport,
 * Klantpagina. Links, geen ARIA-tabs - elk tabblad is een eigen adres - in de
 * vorm die Instellingen ook gebruikt ({@link HeaderTabs}).
 */
export function OrderTabs({ tabs }: OrderTabsProps) {
    return <HeaderTabs label={orderLayoutCopy.tabsLabel} tabs={tabs} />;
}
